import { render, staticRenderFns } from "./areaBasic.vue?vue&type=template&id=1ca65779&scoped=true"
import script from "./areaBasic.vue?vue&type=script&lang=js"
export * from "./areaBasic.vue?vue&type=script&lang=js"
import style0 from "./areaBasic.vue?vue&type=style&index=0&id=1ca65779&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca65779",
  null
  
)

export default component.exports